import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDataFromOneDrive, getDataFromGoogleSheet } from '../services/api';
import { RootState } from '.';
import { DataState } from '../interfaces/timesheet';
import config from '../services/config';

const initialState: DataState = {
  data: null,
  loading: false,
  error: null,
  lastFetched: null
};

export const fetchData = createAsyncThunk(
  'data/fetchData',
  async (_, { getState }) => {
    try {
      console.log("config.nodeEnv----->",config.nodeEnv)
      const response = config.nodeEnv.toLocaleLowerCase() === "production" ? await getDataFromOneDrive() : await getDataFromGoogleSheet();

      // If we got the special flag to use redux store, return current data
      if (response.offline) {
        console.log('Using persisted data from Redux store');

        const state = getState() as RootState;
        return state.data.data;
      }
      
      // retyping matricules correctly
      response.data.employees.map(employ => {
        employ.matricule = parseInt(employ.matricule.toString(), 10);
        return employ;
      });
      response.data.foremans.map(foreman => {
        foreman.matricule = parseInt(foreman.matricule.toString(), 10);
        return foreman;
      });
      response.data.sites.map(site => {
        site.matricule = parseInt(site.matricule.toString(), 10);
        return site;
      });
      response.data.workManagers.map(wm => {
        wm.matricule = parseInt(wm.matricule.toString(), 10);
        return wm;
      });

      return response.data;
    } catch (error) {
      // When error occurs (like offline), use the persisted data from Redux store
      console.log('Error fetching data, using persisted data');
      const state = getState() as RootState;

      if (state.data.data) {
        // Return current data from state instead of failing
        return state.data.data;
      }

      return null; // If no data is available, return null
    }
  }
);


const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    clearDataError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lastFetched = new Date().toISOString();
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || 'An unknown error occurred';
      });
  }
});

export const { clearDataError } = dataSlice.actions;
export default dataSlice.reducer;